





























import { defineComponent } from "@vue/composition-api";
import BaseDialog from "@/components/dialog/baseDialog/BaseDialog.vue";
import CardSelector from "@/components/forms/CardSelector/CardSelector.vue";
import { svgIcons } from "@/core/utils/svgIcons";
import { i18n } from "@/locales/i18n";

export default defineComponent({
  name: "StepTrailerMaxWeight",
  components: {
    BaseDialog,
    CardSelector,
  },
  setup(props, { emit }) {
    const cardList: {
      icon: string;
      text: string;
      value: string;
    }[] = [
      {
        icon: svgIcons.weight1,
        text: i18n.tc(
          "VEHICLE_CATEGORY_HELPER.STEP_TRAILER_MAX_WEIGHT.OPTION_MAX3ANDHALF"
        ),
        value: "trailerMax3,5t",
      },
      {
        icon: svgIcons.weight2,
        text: i18n.tc(
          "VEHICLE_CATEGORY_HELPER.STEP_TRAILER_MAX_WEIGHT.OPTION_BETWEEN075AND3ANDHALF"
        ),
        value: "trailerWeightBetween",
      },
      {
        icon: svgIcons.weight3,
        text: i18n.tc(
          "VEHICLE_CATEGORY_HELPER.STEP_TRAILER_MAX_WEIGHT.OPTION_MORETHAN3ANDHALF"
        ),
        value: "trailerWeightMoreThan3,5t",
      },
    ];

    const selection = (value: string) => {
      emit("selectionChanged", value);
    };

    const prevStep = () => {
      emit("prevStep");
    };

    const closeDialog = () => {
      emit("closeDialog");
    };
    return {
      cardList,
      selection,
      closeDialog,
      prevStep,
    };
  },
});
